import React, { useEffect } from 'react';
import { useStore } from 'context/store';
import { SnackbarProvider, useSnackbar } from 'notistack';

function MyApp({ notification }) {
  const { message, variant } = notification;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => message && enqueueSnackbar(message, { variant }), [notification]);

  return null;
}

export default () => {
  const [{ notification }] = useStore();
  return (
    <SnackbarProvider maxSnack={3}>
      <MyApp notification={notification} />
    </SnackbarProvider>
  );
};
